//document.addEventListener('DOMContentLoaded', () => {
$(document).ready(function() {

//  console.log("It works on each visit!")
  $('h1').addClass("tit9");
  $('h2').addClass("tit9");
  $('h3').addClass("tit7");
  $('h4').addClass("tit7");
  $('h5').addClass("tit7");
  $('h6').addClass("tit7");
  $('h7').addClass("tit7");


/*  $(".redchip728_90").click( function(){
    $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-1-1-11.html");
  });

  $(".redchip300_600").click( function(){
    $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-1-1-13.html");
  });

  $(".redchip250_250").click( function(){
    $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-2-1-16.html");
  });

  $(".redchip267_630").click( function(){
    $(this).attr( "href", "https://redchippoker.idevaffiliate.com/131-2-1-17.html");
  });

  $(".holdemmanager").click( function(){
    $(this).attr( "href", "https://holdemmanager.com?a_aid=pokernewb&amp;a_bid=a6deee94");
  });

  $(".pokertracker").click( function(){
    $(this).attr( "href", "https://pokertracker.com/products/PT4/?a_aid=pokernewb&amp;a_bid=2fa70637");
  });

  $(".advancedpokertraining").click( function(){
    $(this).attr( "href", "https://www.advancedpokertraining.com/poker/amember/aff/go/Ovi_Wan");
  });
*/
});
